import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, Divider, ListItemButton, ListSubheader, Popper, TextField, Typography } from "@mui/material";
import { faAngleDown as farAngleDown } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import { faCheck as farCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import React, { useEffect } from "react";
import { getNewValueFromSelection } from "./RichTextFieldCustomToolbar";
export const autocompleteSxProps = {
    ".MuiInput-root::before": {
        border: 0
    },
    ".MuiAutocomplete-popupIndicator, .MuiAutocomplete-clearIndicator": {
        height: "24px",
        width: "24px",
        ":hover": {
            color: "primary.main",
            backgroundColor: "action.hover"
        }
    },
    "& .svg-inline--fa": {
        height: "16px",
        width: "16px"
    }
};
const listItemSxProps = {
    height: "36px",
    minHeight: "unset !important",
    padding: "4px 16px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center !important",
    justifyContent: "space-between !important",
    gap: "8px",
    "&.Mui-selected": {
        backgroundColor: "action.selected"
    },
    "& svg": {
        width: "16px",
        height: "16px"
    }
};
const nameSxProps = {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
};
// Calculate the width of the input field based on the text length
const calculateInputWidth = (text) => {
    const baseWidth = 10; // base width for empty input
    const charWidth = 8; // average width of a character
    const calculatedWidth = baseWidth + text.length * charWidth;
    return calculatedWidth > 170 ? "170px" : `${calculatedWidth}px`;
};
export const getFontNameForClass = (name) => name === null || name === void 0 ? void 0 : name.replace(/[, \W]/g, "");
const quillFormat = "font";
export const FontSelection = ({ fonts, quillRef, className, defaultValue, currentValueRef }) => {
    const [currentValue, setCurrentValue] = React.useState(defaultValue);
    const joinedFonts = fonts.flatMap(font => font.fonts);
    useEffect(() => {
        quillRef.current.getEditor().on("selection-change", (range, oldRange, source) => {
            if (source === "user" && quillRef.current && range && currentValue) {
                const fontName = getNewValueFromSelection(range, quillFormat, quillRef) || getFontNameForClass(currentValue.name);
                const fontOption = joinedFonts.find(font => getFontNameForClass(font.name) === fontName) || defaultValue;
                setCurrentValue(fontOption);
                currentValueRef.current = fontOption.name;
            }
        });
    }, []);
    const changeHandler = (e, newValue) => {
        if (newValue) {
            quillRef === null || quillRef === void 0 ? void 0 : quillRef.current.editor.format(quillFormat, getFontNameForClass(newValue.name), "user");
            setCurrentValue(newValue);
            currentValueRef.current = newValue.name;
        }
    };
    const renderedOptions = () => {
        return (props, option, { selected }) => _createElement(ListItemButton, Object.assign({}, props, { component: "li", key: option.id, sx: listItemSxProps, selected: selected }),
            option.imageUrl ?
                _jsx("img", { style: { minWidth: 0 }, alt: option.name, src: option.imageUrl }) :
                _jsx(Typography, { sx: nameSxProps, children: option.name }),
            selected && (_jsx(FontAwesomeIcon, { icon: farCheck })));
    };
    const renderedInput = () => {
        return (params) => _jsx(TextField, Object.assign({}, params, { variant: "standard", inputProps: Object.assign(Object.assign({}, params.inputProps), { style: { width: calculateInputWidth(params.inputProps.value) } }), autoComplete: "off" }));
    };
    return _jsx(Autocomplete, { size: "small", sx: autocompleteSxProps, className: className, value: currentValue, disableClearable: true, onChange: changeHandler, groupBy: (option) => { var _a; return (_a = fonts.find(fontGroup => fontGroup.fonts.includes(option))) === null || _a === void 0 ? void 0 : _a.group.label; }, options: joinedFonts, renderGroup: (groupProps) => (fonts.length > 1 ? (_jsxs(React.Fragment, { children: [_jsx(ListSubheader, { sx: { top: "-8px" }, children: _jsx(Typography, { variant: "caption", children: groupProps.group }) }), groupProps.children, // render divider only if not the last group
                groupProps.group !== fonts[fonts.length - 1].group.label &&
                    _jsx(Divider, { sx: { margin: "8px 0" } })] }, groupProps.key))
            : groupProps.children), isOptionEqualToValue: (option, value) => option.id === value.id, getOptionLabel: (option) => option.name, renderInput: renderedInput(), renderOption: renderedOptions(), popupIcon: _jsx(FontAwesomeIcon, { icon: farAngleDown }), PopperComponent: (props) => _jsx(Popper, Object.assign({}, props, { placement: "bottom-start", style: { width: "220px" } })), noOptionsText: "" });
};
//# sourceMappingURL=FontSelection.js.map